import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AppPartnerSelectionPopupPage} from "../app-partner-selection-popup/app-partner-selection-popup";
import {AppYubleCodePopupPage} from "../app-yuble-code-popup/app-yuble-code-popup";

/**
 * Generated class for the IntroAokSelectionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-aok-selection',
  templateUrl: 'intro-aok-selection.html',
})
export class IntroAokSelectionPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IntroAokSelectionPage');
  }


  aokResponse(response: boolean) {
    if(response) {
      this.navCtrl.push(AppYubleCodePopupPage).then(_ => {
        this.navCtrl.remove(1, 1);
      })
    } else {
      this.navCtrl.push(AppPartnerSelectionPopupPage).then(_ => {
        this.navCtrl.remove(1, 1);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intro-aok-selection/intro-aok-selection.ts